import { useEffect, useState } from 'react';
import { Button, Input, Modal } from 'antd';
import styles from './index.module.scss';

const { TextArea } = Input;

const PromptEditModal = ({ open, value, title = '编辑文本', onCancel, onSave, maxLength = 2000 }) => {
    const [draft, setDraft] = useState(value || '');

    useEffect(() => {
        if (!open) return;
        setDraft(value || '');
    }, [open, value]);

    return (
        <Modal
            open={open}
            title={title}
            onCancel={onCancel}
            footer={null}
            width={848}
            centered
            destroyOnHidden
            className={styles.modal}
            modalRender={(modalNode) => (
                <div data-free-canvas-panel-root="true">
                    {modalNode}
                </div>
            )}
        >
            <div className={styles.body}>
                <TextArea
                    value={draft}
                    onChange={(event) => setDraft(event.target.value)}
                    maxLength={maxLength}
                    className={styles.input}
                    autoSize={false}
                    style={{ width: 800, height: 476 }}
                    onMouseDown={(event) => event.stopPropagation()}
                    onClick={(event) => event.stopPropagation()}
                />
                <div className={styles.actions}>
                    <Button className={styles.cancelBtn} onClick={onCancel}>
                        取消
                    </Button>
                    <Button
                        type="primary"
                        className={styles.saveBtn}
                        onClick={() => onSave?.(draft)}
                    >
                        保存
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default PromptEditModal;
